import gql from "graphql-tag";

export const UPDATE_USER_NAME_MUTATION = gql`
  mutation UpdateUserName($name: String!) {
    updateUserName(name: $name)
  }
`;
